module.exports = __webpack_public_path__ + "img/MX-A024035D-BS24W-HQ.99d0210f.png";